module.exports = __webpack_public_path__ + "static/media/Al_Jazeera.d73356c1.png";